import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { Team } from '../../teams/team.interface';
import { Employer } from '../employer.interface';

export class EmployerTeamService {
   async getTeams(employerId: number, query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<Team>>>(`/employers/${employerId}/teams`, { params: { ...query } });
      return response.data;
   }

   async addEmployerTeams(employerId: number, teams: Array<Team>) {
      const response = await http.post<ApiResource<Employer>>(`/employers/${employerId}/teams-batch`, { teams });
      return response.data.data.teams;
   }

   async removeEmployerTeams(employerId: number, teams: Array<Team>) {
      const response = await http.delete<Array<number>>(`/employers/${employerId}/teams-batch`, { data: { teams } });
      return response.data;
   }
}
